// extracted by mini-css-extract-plugin
export default {"main":"Reviews_main__KUbMP","boxCont":"Reviews_boxCont__0xUSa","box":"Reviews_box__AOfUI"};